export default {
    en: {
        title: 'Example',
        number: 1,
        diagramId: 0,
        answer: '',
        example: true,
        interactiveBoxNumber: [1],
        blocks:
            [
                {
                    task: {
                        question: 'Physical laws dictate that an organism’s every action is the result of previous events',
                        answer: 'Physical laws dictate that an <span class="highlight__answer highlight__answer_example">organism’s</span> every action is the result of previous events'
                    }
                },
                {
                    task: {
                        question: 'Human beings are organisms, and consequently subject to those laws',
                        answer: 'Human beings are <span class="highlight__answer highlight__answer_example">organisms</span>, and consequently subject to those laws'
                    }
                },
                {
                    task: {
                        question: 'Thus, human behaviour must result from a complete sequence of causes and effects that is completely out of our control',
                        answer: 'Thus, human behaviour must result from a complete sequence of causes and effects that is completely out of our control'
                    }
                }
            ]
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a1/deductiveReasoning/i18n/exercise1.js